<template >
    <j-image-upload :disabled="sfksc" @change="getImg" isMultiple :value="model.imgUrl.split(',')"></j-image-upload>
</template>

<script>
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'AdviceForHelpForm',
    components: {
      JFormContainer,
      JUpload,
      JImageUpload,
      JDictSelectTag,
    },
    props: {
      odd: String,
      sfksc:{
        type: Boolean,
        default: true
      },
      getPopupContainer:{
        type: Function,
        default: (node) => node.parentNode
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {
          imgUrl:""
        }
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.$nextTick(() => {
        this.model.imgUrl = this.odd;
      })
    },
    methods: {
      getImg(obj){
        this.$emit('tpkt',obj);
      }
    }
    
  }
</script>